import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField } from '../../components/ui';
import { useForgotUsername } from '../../hooks/react-query/useUserData';
import { SpinnerIcon } from '../../icons';
import ReactPhoneInput from 'react-phone-input-2';
import el from '../../locale/react-phone-input-2/el.json';
import { toast } from '../../components/ui/Toast/useToast';

const ForgotUsername = () => {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('+30');
  const [email, setEmail] = useState('');
  const [vat, setVat] = useState('');
  const [plateNo, setPlateNo] = useState('');
  const [consent, setConsent] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const { mutate: handleUsernameSubmit, isLoading } = useForgotUsername();

  const toFieldErrors = (invalid) => {
    if (!invalid || typeof invalid !== 'object') return {};

    return Object.fromEntries(
      Object.entries(invalid)
        .map(([key, messages]) => [
          key,
          Array.isArray(messages)
            ? messages.filter(Boolean).join(' ')
            : String(messages ?? ''),
        ])
        .filter(([, message]) => Boolean(message))
    );
  };

  const handleSubmit = (event) => {
    // navigate('/');
    event.preventDefault();
    setFieldErrors({});
    const payload = { 
      "firstname": firstName,
      "lastname": lastName , 
      "email": email, 
      "phone": phone?.startsWith('+') ? phone : `+${phone}`,
      "vat": vat,
      "plateno": plateNo, 
      "consent": consent };
    handleUsernameSubmit(payload, {
      onSuccess: (data) => {
        if (data?.data?.status === 'fail') {
          setFieldErrors(toFieldErrors(data?.exceptions?.invalid));
          console.warn('Validation error:', data?.exceptions?.invalid);
        } else {
          toast({
              variant: 'success',
              description: "Το αίτημα στάλθηκε επιτυχώς.",
          });
          navigate('/');
        }
      },
      onError: (e) => {
        console.warn('forgot-username failed:', e);
        setFieldErrors(toFieldErrors(e?.response?.data?.exceptions?.invalid));
      },
    });
  };

  return (
    <div
      className="w-[100vw] flex justify-center items-start lg:items-center min-h-[calc(100vh-72px)] overflow-x-hidden px-4 md:px-6 py-6 lg:py-10"
    >
      <form
        onSubmit={handleSubmit}
        className="flex flex-col items-center gap-8 lg:gap-10 w-full max-w-[900px] lg:max-w-[1200px] md:bg-white rounded-[20px] py-10 md:px-6 lg:px-44"
      >
        <div className='flex flex-col gap-2 items-center'>
          <h2 className="">Ξέχασες το email σου;</h2>
          <p className='text-label w-9/12 text-center'>Συμπλήρωσε τη φόρμα και θα επικοινωνήσουμε μαζί σου για την ανάκτηση του email σου.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-[720px]">
            <TextField
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
                if (fieldErrors?.firstname)
                  setFieldErrors((prev) => ({ ...prev, firstname: '' }));
              }}
              className="p-2 border border-[#A5A5A5] rounded-[8px] w-full lg:text-black text-grenite"
              label="Όνομα*"
              placeholder=""
              id="firstName"
              error={fieldErrors?.firstname}
            />

            <TextField
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                if (fieldErrors?.lastname)
                  setFieldErrors((prev) => ({ ...prev, lastname: '' }));
              }}
              className="p-2 border border-[#A5A5A5] rounded-[8px] w-full lg:text-black text-grenite"
              label="Επώνυμο*"
              placeholder=""
              id="lastName"
              error={fieldErrors?.lastname}
            />

            <TextField
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (fieldErrors?.email)
                  setFieldErrors((prev) => ({ ...prev, email: '' }));
              }}
              className="p-2 border border-[#A5A5A5] rounded-[8px] w-full lg:text-black text-grenite"
              label="Email επικοινωνίας*"
              placeholder=""
              id="email"
              error={fieldErrors?.email}
            />

            <div className="flex flex-col gap-1" key={"phone"}>
              <label
                htmlFor={"phone"}
                className="text-label text-fadedgrey"
              >
                Κινητό*
              </label>
              <ReactPhoneInput
                key={"phone"}
                id={"phone"}
                country="gr"
                countryCodeEditable={false}
                autoFormat={false}
                containerClass={`flex gap-2 rounded-[8px] border border-[#A5A5A5]`}
                inputClass="!border-0 !outline-none !ring-0 !shadow-none !w-full !rounded-lg"
                localization={el}
                specialLabel="Phone"
                value={phone}
                placeholder=""
                error={fieldErrors?.phone}
                onChange={(value) => {
	                setPhone(value);
                  if (fieldErrors?.phone)
                    setFieldErrors((prev) => ({ ...prev, phone: '' }));
	              }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
              />
              {fieldErrors?.phone && (
                <p className="text-label text-primary">
                  {fieldErrors?.phone}
                </p>
              )}
            </div>

            <TextField
              value={vat}
              onChange={(e) => {
                setVat(e.target.value);
                if (fieldErrors?.vat)
                  setFieldErrors((prev) => ({ ...prev, vat: '' }));
              }}
              className="p-2 border border-[#A5A5A5] rounded-[8px] w-full lg:text-black text-grenite"
              label="ΑΦΜ"
              placeholder=""
              id="vat"
              error={fieldErrors?.vat}
            />

            <TextField
              value={plateNo}
              onChange={(e) => {
                setPlateNo(e.target.value);
                if (fieldErrors?.plateno)
                  setFieldErrors((prev) => ({ ...prev, plateno: '' }));
              }}
              className="p-2 border border-[#A5A5A5] rounded-[8px] w-full lg:text-black text-grenite"
              label="Πινακίδα"
              placeholder=""
              id="plateno"
              error={fieldErrors?.plateno}
            />

            <label className="flex items-center gap-2 w-full text-sm text-grenite md:col-span-2">
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => {
                  setConsent(e.target.checked);
                  if (fieldErrors?.consent)
                    setFieldErrors((prev) => ({ ...prev, consent: '' }));
                }}
              />
              <span>
                Έχω ενημερωθεί για την επεξεργασία των δεδομένων μου σύμφωνα με την{' '}
                <a
                  href="https://www.myavis.gr/el/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary underline"
                >
                  Πολιτική Απορρήτου
                </a>
              </span>
            </label>
            {fieldErrors?.consent && (
              <p className="text-label text-primary md:col-span-2">
                {fieldErrors.consent}
              </p>
            )}
          </div>
          <div className="flex gap-3 justify-center flex-col-reverse w-full max-w-[720px] md:flex-row">
            <button
              type="button"
              className="btn-secondary"
              onClick={() => navigate('/')}
            >
              Ακύρωση
            </button>

            <button
              type="submit"
              disabled={
                !firstName.trim() ||
                !lastName.trim() ||
                !email.trim() ||
                phone === '+30' ||
                !consent
              }
              className="btn-primary flex flex-row gap-2 justify-center items-center"
            >
              <p>Αίτημα ανάκτησης</p>
              {isLoading && <SpinnerIcon className="w-4 h-4 fill-white"/>}
            </button>
        </div>
      </form>
    </div>
  );
};

export default ForgotUsername;
